import { OnSpotFileLists } from '@/model/onSpot/OnSpot';
import { Icon } from '@/comp/icon/icon';

export const UploadFileListReview = ({ fileLists }: { fileLists: OnSpotFileLists }) => {
    return (
        <article className="file-list-container">
            <div className="container">
                <h2 className="color-primary">
                    <Icon name="description" size={28} ariaHidden /> Ihre Nachweise
                </h2>
                <div className="question-container">
                    {Object.keys(fileLists).length > 0 ? (
                        <>
                            <h4 className="question">Diese Dokumente haben Sie hochgeladen:</h4>
                            <ul>
                                {Object.keys(fileLists).map((key: string) => {
                                    return fileLists[key].map((file, index: number) => {
                                        return <li key={`file-${key}-${index}`}>{`- ${file.file.name}`}</li>;
                                    });
                                })}
                            </ul>
                        </>
                    ) : (
                        <h4 className="question">Sie haben keine Nachweise eingereicht</h4>
                    )}
                </div>
            </div>
        </article>
    );
};
export default UploadFileListReview;
